import React from "react";
import { graphql } from "gatsby";
import { Col, Container, Row } from "react-bootstrap";
import ExtractRichText from "../../molecules/ExtractRichText";
import "./columnEqual.scss";

const colMap = {
  1: "",
  2: "col-sm-12 col-md-12 col-lg-6",
  3: "col-sm-12 col-md-12 col-lg-4",
  4: "col-sm-12 col-md-6 col-lg-3",
};
export const ParagraphColumnEqual = ({ node }) => {
  const {
    field_component_title = "",
    field_component_subtitle = "",
    field_cta,
    relationships,
  } = node;
  const length = relationships?.field_column_content?.length;

  return (
    <div className="equal-column-wrapper">
      <div className="equal-column-container title-container">
        {Boolean(field_component_title) && (
          <h2 data-aos="underlined" className="underlined">
            {field_component_title}
          </h2>
        )}
        {Boolean(field_component_subtitle) && (
          <h4>{field_component_subtitle}</h4>
        )}
      </div>
      <div className={`equal-column equal-column-${length}`}>
        <div className="row">
          {relationships?.field_column_content?.map((p) => (
            <div className={`eq-col col-xs-12 ${colMap[length]}`}>
              {p?.field_heading && (
                <p className="stat-heading">{p?.field_heading}</p>
              )}
              {p?.field_component_title && (
                <h4 className="stat-title">{p?.field_component_title}</h4>
              )}
              {p?.field_body_text && (
                <div className="stat-desc">
                  <ExtractRichText richText={p?.field_body_text?.value} />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      {Boolean(field_cta?.title) && (
        <Container className="btn-container general-container">
          <Row>
            <Col>
              <a
                target={field_cta?.options?.attributes?.target}
                href={field_cta?.url}
                className="btn btn-white mt-3"
              >
                {field_cta?.title}
              </a>
            </Col>
          </Row>
        </Container>
      )}
    </div>
  );
};

export const fragment = graphql`
  fragment ParagraphColumnEqual on paragraph__column_equal {
    field_component_title
    field_component_subtitle
    field_cta {
      title
      uri
      url
      options {
        attributes {
          target
        }
      }
    }
    relationships {
      field_column_content {
        field_component_title
        field_body_text {
          value
        }
        field_heading
      }
    }
  }
`;
